<div class="wrapper">
  <form [formGroup]="form">
    <div class="two-items">
      <div class="form-component inspection-forms-field">
        <mat-form-field>
          <mat-select formControlName="Layer" matTooltip="{{ 'configurations-fields.tooltips.Layer' | translate }}">
            <mat-option *ngFor="let layer of layers" [value]="layer.Id"> {{ layer.Name }} ({{ layer.Slug }})
            </mat-option>
          </mat-select>
          <mat-placeholder>{{
            layers.length ? ("configurationTab.layer" | translate) : ("configurationTab.noLayer" | translate)
            }}</mat-placeholder>
        </mat-form-field>
        <mat-icon class="update-icon" mat-icon-button (click)="updateLayers()">sync</mat-icon>
      </div>

      <div class="form-component main-color" *ngIf="isDisplayForCurrentSourceType(configurationFields.MainColor)">
        <mee-color-picker [position]="ColorPickerPosition.Left" formControlName="MainColor"></mee-color-picker>
      </div>
    </div>

    <!--AltitudeMode (UI name - Elevation Type)-->

    <div class="two-items">
      <div class="form-component" *ngIf="isDisplayForCurrentSourceType(configurationFields.AltitudeMode)">
        <mat-form-field>
          <mat-select matTooltip="{{ 'configurations-fields.tooltips.AltitudeMode' | translate }}"
                      formControlName="AltitudeMode">
            <mat-option *ngFor="let mode of altitudeModesModel" [value]="mode.value">
              {{ mode.title | translate }}
            </mat-option>
          </mat-select>
          <mat-placeholder>{{ "configurations-fields.AltitudeMode" | translate }}</mat-placeholder>
        </mat-form-field>
      </div>

      <div class="form-component with-measurement"
           *ngIf="isDisplayForCurrentSourceType(configurationFields.VerticalDatum)">
        <mee-vertical-datum [espg]="espg" formControlName="VerticalDatum"></mee-vertical-datum>

        <mat-form-field matTooltip="{{ 'configurations-fields.tooltips.MeasurementSystem' | translate }}">
          <mat-select placeholder="UoM" formControlName="VerticalMeasurementSystem">
            <mat-option *ngFor="let measurementSystemOption of measurementSystemOptions"
                        [value]="measurementSystemOption.value">
              {{ measurementSystemOption.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="two-items with-hint">
      <div
        class="form-component"
        [ngClass]="{ 'with-measurement': isDisplayForCurrentSourceType(configurationFields.MeasurementSystem) }"
        *ngIf="isShowCoordinateSystem"
      >
        <mat-form-field *ngIf="isDisplayForCurrentSourceType(configurationFields.CoordinateSystem)">
          <input
            formControlName="CoordinateSystem"
            matInput
            type="number"
            min="1"
            matTooltip="{{ 'configurations-fields.tooltips.CoordinateSystem' | translate }}"
            placeholder="{{ 'configurations-fields.CoordinateSystem' | translate }}"
          />

          <ng-container *ngIf="!isDisplayForCurrentSourceType(configurationFields.MeasurementSystem)">
            <ng-container [ngTemplateOutlet]="epsgTip"></ng-container>
          </ng-container>

        </mat-form-field>

        <mat-form-field
          *ngIf="isDisplayForCurrentSourceType(configurationFields.MeasurementSystem)"
        >
          <mat-select placeholder="UoM" formControlName="MeasurementSystem"
                      matTooltip="{{ 'configurations-fields.tooltips.MeasurementSystem' | translate }}"
          >
            <mat-option *ngFor="let measurementSystemOption of measurementSystemOptions"
                        [value]="measurementSystemOption.value">
              {{ measurementSystemOption.title }}
            </mat-option>
          </mat-select>

          <ng-container [ngTemplateOutlet]="epsgTip"></ng-container>

        </mat-form-field>

        <ng-template #epsgTip>
          <img (click)="openEpsgHintDialog($event)"
               class="hint-icon"
               [ngStyle]="{ 'left' : isDisplayForCurrentSourceType(configurationFields.MeasurementSystem) ? '55px' : '245px'}"
               src="/assets/img/icons/help-question.svg" alt="hint-icon"
               matTooltip="{{ 'configurations-fields.tooltips.СoordinateSystemHint' | translate }}"
          >
        </ng-template>

      </div>

      <div class="form-component with-measurement"
           *ngIf="isDisplayForCurrentSourceType(configurationFields.DefaultDepth)">
        <mee-configuration-compound-input-new
          formControlName="DefaultDepth"
          placeholder="{{ 'configurations-fields.DefaultDepth' | translate }}"
          helpTooltip="{{ 'configurations-fields.tooltips.DepthAltitude' | translate }}"
        ></mee-configuration-compound-input-new>
      </div>
    </div>

    <!--four toggles below but for now for different source types refs #53256-->

    <div class="two-items two-toggles">
      <ng-container *ngIf="isDisplayForCurrentSourceType(configurationFields.IsLocalCoordinateSystem)">
        <div class="form-component toggle">
          <mat-slide-toggle formControlName="IsLocalCrs" color="primary">
            {{ "sources.fields-placeholders.isUseLocalCoordinatesSystem" | translate }}
          </mat-slide-toggle>
        </div>
      </ng-container>


      <ng-container *ngIf="isDisplayForCurrentSourceType(configurationFields.IsMeshInteractionEnabled)">
        <div class="form-component toggle">
          <mat-slide-toggle formControlName="IsMeshInteractionEnabled" name="EnableModelInteractions" color="primary">
            {{ "sources.fields-placeholders.isEnableModelInteractions" | translate }}
          </mat-slide-toggle>
        </div>
      </ng-container>

      <ng-container *ngIf="isDisplayForCurrentSourceType(configurationFields.FullModel)">
        <div class="form-component toggle">
          <mat-slide-toggle formControlName="FullModel" name="ExtendViewingRange" color="primary">
            {{ "sources.fields-placeholders.isUseFullModel" | translate }}
          </mat-slide-toggle>
        </div>
      </ng-container>
    </div>
  </form>
</div>
